module.exports = __webpack_public_path__ + "img/s-hair.c30516c6.svg";